
import React from 'react';

const PopAnimationStyle: React.FC = () => {
  // Define the pop animation style for the gift icon
  const popAnimationStyle = `
    @keyframes pop {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.3);
      }
      100% {
        transform: scale(1);
      }
    }
  `;

  return <style>{popAnimationStyle}</style>;
};

export default PopAnimationStyle;
